import { context } from '../constants/context';
import { halClient } from '../hal';
import { BBModel } from '../bb_model';
import { bbAuthorisation } from '../admin/bb_authorisation';
import loginStorage from '../admin/login_storage';

const adminLogin = {
    login(form, options) {

        return new Promise((resolve, reject) => {

            let url = `${context.apiUrl}/api/${context.apiVersion}/login/admin`;

            if ((options != null) && (options.company_id != null)) {
                url = `${url}/${options.company_id}`;
            }

            halClient.$post(url, options, form).then(
                (login) => {
                    if (login.$has('administrator')) {
                        login.$get('administrator').then(
                            (user) => {
                                user = new BBModel.Admin.User(user);
                                user = this.setUser(user);
                                resolve(user);
                            }
                        );
                    } else if (login.$has('administrators')) {
                        const loginModel = new BBModel.Admin.Login(login);
                        resolve(loginModel);
                    } else {
                        reject('No admin account for login');
                    }
                },
                (err) => {
                    if (err.response && err.response.status === 400) {
                        const login = halClient.$parse(err.response.data);
                        if (login.$has('administrators')) {
                            const loginModel = new BBModel.Admin.Login(login);
                            resolve(loginModel);
                        } else {
                            reject(err);
                        }
                    } else {
                        reject(err);
                    }
                }
            );
        });
    },

    ssoLogin(ssoToken, companyId, childCompanyId) {

        if (!ssoToken) {
            throw new Error('missing ssoToken');
        }

        if (!companyId) {
            throw new Error('missing companyId');
        }

        return new Promise((resolve, reject) => {
            const url = `${context.apiUrl}/api/${context.apiVersion}/login/admin_sso/${companyId}`;
            const data = {
                token: ssoToken
            };

            if (childCompanyId) {
                data.company_id = childCompanyId;
            }

            halClient
                .$post(url, {}, data)
                .then((login) => {
                    if (login.$has('administrator')) {
                        login.$get('administrator').then(
                            (user) => {
                                user = new BBModel.Admin.User(user);
                                user = this.setUser(user);
                                resolve(user);
                            }
                        );
                    } else if (login.$has('administrators')) {
                        const loginModel = new BBModel.Admin.Login(login);
                        resolve(loginModel);
                    } else {
                        reject('No admin account for login');
                    }
                })
                .then(resolve)
                .catch((err) => {
                    if (err.response && err.response.status === 400) {
                        const login = halClient.$parse(err.response.data);
                        if (login.$has('administrators')) {
                            const login_model = new BBModel.Admin.Login(login);
                            resolve(login_model);
                        } else {
                            reject(err);
                        }
                    } else {
                        reject(err);
                    }
                });
        });
    },

    setUser(user) {
        if (!(user instanceof BBModel.Admin.User)) {
            throw new Error('not an instance of BBModel.Admin.User');
        }
        if (user.company_id) {
            loginStorage.storeUser(user);
            bbAuthorisation.setUser(user);
        }

        return user;
    },

    checkUser() {
        return new Promise((resolve, reject) => {

            if (bbAuthorisation.getUser()) {
                resolve(bbAuthorisation.getUser());
                return;
            }

            const user = loginStorage.restoreUser();
            if (user) {
                bbAuthorisation.setUser(user);
                resolve(user);
                return;
            }

            reject();
        });
    },

    logout() {
        return new Promise((resolve, reject) => {

            bbAuthorisation.clearAll();
            loginStorage.clearAll();
            localStorage.setItem('loggedIn', false);

            const url = `${context.apiUrl}/api/${context.apiVersion}/login`;
            halClient.$del(url);

            resolve();
        });
    },

    setCompany(companyId) {
        return new Promise((resolve, reject) => {
            const url = `${context.apiUrl}/api/${context.apiVersion}/login/admin`;
            const params = { company_id: companyId };

            halClient.$put(url, {}, params)
                .then((login) => {
                        if (login && login.$has('administrator')) {
                            login.$get('administrator').then(
                                (user) => {
                                    user = new BBModel.Admin.User(user);
                                    user = this.setUser(user);
                                    resolve(user);
                                },
                                err => reject(err)
                            );
                        } else {
                            reject();
                        }
                    },
                    err => reject(err)
                );
        });
    }
};

export {
    adminLogin
};
